import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { InlineSpinner } from '../../design-system/components/InlineSpinner';

/**
 * Fallback visible pour les routes lazy-chargées.
 * Évite l'écran blanc (« ça mouline / rien n'apparaît ») pendant le download du chunk.
 */
export const RouteLazyFallback: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <div
      aria-busy="true"
      aria-live="polite"
      data-testid="route-lazy-fallback"
      style={{
        minHeight: '60vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        backgroundColor: 'transparent',
        color: '#666',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      }}
    >
      <InlineSpinner size="2xl" />
      <span style={{ fontSize: 14 }}>{t('routeSuspense.loadingPage')}</span>
    </div>
  );
};

const RouteSuspense: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense fallback={<RouteLazyFallback />}>{children}</Suspense>
);

export default RouteSuspense;
